import { BlockResponse } from '../../../types/block';
import { ApiAbstract } from '../abstract';

export class ApiBlock extends ApiAbstract<any, BlockResponse> {}
